<script >
export default {
  name: "widgetActionIcon",
  props: [
    'action'
  ]
};
</script>

<template>
  <i class="fa-solid fa-envelope fa-fw text-primary me-2"
     v-if="action.actionType == 4"></i>
  <i class="fa-solid fa-phone-office fa-fw text-primary me-2"
     v-else-if="action.actionType == 9"></i>
  <i class="fa-solid fa-handshake text-warning-emphasis fa-fw me-2"
     v-else-if="action.actionType == 1"></i>
  <i class="fa-solid fa-file-invoice-dollar text-success fa-fw me-2"
     v-else-if="action.actionType == 2"></i>
  <i class="fa-solid fa-calendar-clock text-danger fa-fw me-2"
     v-else-if="action.actionType == 10"></i>
  <i class="fa-solid fa-bolt text-danger fa-fw me-2"
     v-else-if="action.actionType == 12"></i>
  <i class="fa-solid fa-bolt fa-fw text-secondary me-2" v-else></i>
</template>

<style scoped>

</style>